module.exports = __webpack_public_path__ + "img/compact.3356f511.png";